exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.no-data[data-v-42bdc080]{height:45.333vw;content:\"viewport-units-buggyfill; height: 45.333vw\"\n}\n.no-data .no-data-img[data-v-42bdc080]{width:16vw;height:16vw;content:\"viewport-units-buggyfill; width: 16vw; height: 16vw\"\n}", "", {"version":3,"sources":["/home/ylp/ylp-leadmall-c/src/components/NullData.vue"],"names":[],"mappings":";AACA,0BAA0B,gBAAgB,oDAAoD;CAC7F;AACD,uCAAuC,WAAW,YAAY,6DAA6D;CAC1H","file":"NullData.vue","sourcesContent":["\n.no-data[data-v-42bdc080]{height:45.333vw;content:\"viewport-units-buggyfill; height: 45.333vw\"\n}\n.no-data .no-data-img[data-v-42bdc080]{width:16vw;height:16vw;content:\"viewport-units-buggyfill; width: 16vw; height: 16vw\"\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42bdc080","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NullData.vue
// module id = 603s
// module chunks = 1